/* eslint-disable no-console */

import { register } from "register-service-worker";
import { tandaiAdaPembaruan } from "@/utils/swUpdate";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB");
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    // Versi baru sudah terunduh penuh dan menunggu giliran. Sebelumnya di sini
    // cuma ada console.log, sehingga versi lama terus disajikan sampai SELURUH
    // jendela aplikasi ditutup — dan karena index.html ikut di-precache,
    // refresh biasa pun tidak menolong. Sekarang pengguna diberi tahu lewat
    // banner dan dia sendiri yang memilih kapan memuat ulang; jangan pernah
    // memuat ulang otomatis, aplikasi ini penuh form yang isinya bisa hilang.
    updated(registration) {
      console.log("New content is available; please refresh.");
      tandaiAdaPembaruan(registration);
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
